import PageMeta from '@/components/base/PageMeta';
import ScrollToTop from '@/components/base/ScrollToTop';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import HotComics from './components/HotComics';
import LatestUpdates from './components/LatestUpdates';

export default function Home() {
  const websiteJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '尾巴漫画',
    url: typeof window !== 'undefined' ? window.location.origin : '',
    description: '尾巴漫画汇聚无删减韩国漫画，下拉式免费韩漫大全在线阅读便捷高效，热门韩漫实时跟进，带给您舒适体验。',
    potentialAction: {
      '@type': 'SearchAction',
      target: {
        '@type': 'EntryPoint',
        urlTemplate: `${typeof window !== 'undefined' ? window.location.origin : ''}/category/all?q={search_term_string}`,
      },
      'query-input': 'required name=search_term_string',
    },
  };

  const orgJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '尾巴漫画',
    url: typeof window !== 'undefined' ? window.location.origin : '',
    description: '免费韩国漫画在线阅读平台',
  };

  return (
    <>
      <PageMeta
        title="韩国漫画无删减漫画下拉式-免费韩漫大全-尾巴漫画"
        description="尾巴漫画汇聚无删减韩国漫画，下拉式免费韩漫大全在线阅读便捷高效，热门韩漫实时跟进，带给您舒适体验。"
        keywords="韩国漫画,无删减漫画,下拉式韩漫,免费韩漫大全,尾巴漫画"
        canonicalUrl="/"
        ogImage="https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20collection%20display%2C%20colorful%20manga%20covers%20arranged%20artistically%2C%20warm%20coral%20and%20amber%20tones%2C%20reading%20platform%20branding%2C%20clean%20modern%20layout%2C%20Korean%20digital%20illustration%20style&width=1200&height=630&seq=og-home&orientation=landscape"
        jsonLd={{ ...websiteJsonLd, ...orgJsonLd }}
      />
      <ScrollToTop />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryNav />
        <HotComics />
        <LatestUpdates />
        <section className="py-12 md:py-16 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6 text-center">
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-4">为什么选择尾巴漫画？</h2>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mt-8">
              <div className="p-6 rounded-lg bg-background-100 border border-background-200/70">
                <div className="flex items-center justify-center w-14 h-14 md:w-16 md:h-16 mx-auto mb-4 rounded-full bg-primary-100">
                  <i className="ri-book-open-line text-2xl text-primary-500 w-6 h-6 flex items-center justify-center"></i>
                </div>
                <h3 className="text-base font-semibold text-foreground-950 mb-2">无删减完整版</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">所有漫画均为无删减版本，还原韩国漫画原汁原味的阅读体验，不含任何修改或删减内容。</p>
              </div>
              <div className="p-6 rounded-lg bg-background-100 border border-background-200/70">
                <div className="flex items-center justify-center w-14 h-14 md:w-16 md:h-16 mx-auto mb-4 rounded-full bg-accent-100">
                  <i className="ri-smartphone-line text-2xl text-accent-500 w-6 h-6 flex items-center justify-center"></i>
                </div>
                <h3 className="text-base font-semibold text-foreground-950 mb-2">下拉式阅读</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">采用下拉式阅读模式，无需翻页，滑动即可连续阅读。适配手机和电脑，随时随地畅享漫画。</p>
              </div>
              <div className="p-6 rounded-lg bg-background-100 border border-background-200/70">
                <div className="flex items-center justify-center w-14 h-14 md:w-16 md:h-16 mx-auto mb-4 rounded-full bg-secondary-100">
                  <i className="ri-fire-line text-2xl text-secondary-500 w-6 h-6 flex items-center justify-center"></i>
                </div>
                <h3 className="text-base font-semibold text-foreground-950 mb-2">实时更新</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">热门韩漫第一时间跟进更新，与韩国连载进度同步，不错过任何一话精彩内容。</p>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}